import ApiService from "@/api";
import EnumProjectType from "@/api/Main/dataSource/api/projects/base/entities/enums/EnumProjectType";
import ProjectSearchRequest from "@/api/Main/dataSource/api/projects/base/i-service/models/ProjectSearchRequest";
import { ProjectModel, ResponseModel } from "@/models";

/**Сервис для получения информации о проектах */
export class AdapterService {
  /**Сервис для использования API */
  api = new ApiService();

  /**Получить список проектов */
  async GetProjects(value: string = ""): Promise<ResponseModel<ProjectModel[]>> {
    const result = new ResponseModel<ProjectModel[]>();

    try {
      const response = await this.api.Main.ProjectBaseService.searchAsync(
        new ProjectSearchRequest({ Name: value, Status: [EnumProjectType.Active] }),
      );
      result.Value = response.Projects.map((x) => new ProjectModel(x as any));
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      console.error("ERROR ProjectBaseService.Search", e);
    }

    return result;
  }
}
